import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'
import config from '@/config'
import axios from 'axios'

export const fetchBannersQuery = gql`
query SearchBanners($limit: Int!, $offset: Int!) {
  banner_aggregate {
    aggregate {
      count
    }
  }
  banner(order_by: {created_at: desc}, limit: $limit, offset: $offset) {
    id
    created_at
    max_view
    is_active
    start_date
    end_date
    view_count
    catalog_click_count
    website_click_count
    organization {
      name
    }
  }
}
`
export const fetchBannerByIdQuery = gql`
  query SearchBanner($banner_id: Int!) {
    banner(where: {id: {_eq: $banner_id}}) {
      id
      image
      max_view
      organization_id
      start_date
      end_date
      is_active
      title
    }
  }
`
export const createBannerMutation = gql`
  mutation CreateBanner($data: [banner_insert_input!]!) {
    insert_banner(objects: $data) {
      affected_rows
      returning {
        id
      }
    }
  }
`
export const updateBannerMutation = gql`
  mutation UpdateBanner($bannerId: Int!, $data: banner_set_input!) {
    update_banner(where: {id: {_eq: $bannerId}}, _set: $data) {
      affected_rows
      returning {
        id
        image
        max_view
        organization_id
        start_date
        end_date
        is_active
        title
      }
    }
  }
`

const banner = {
  namespaced: true,
  state: {
    banners: [],
    banner: {},
    banners_count: 0,
    uploadResult: {}
  },
  actions: {
    init ({ commit }) {
      try {
        commit('SET_BANNER', {})
        commit('SET_UPLOAD_RESULTS', {})
        commit('SET_BANNERS', [])
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchAll ({ commit }, filter) {
      try {
        let requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchBannersQuery,
          variables: {
            limit: filter.limit,
            offset: filter.offset
          }
        }

        const result = await apolloClient.query(requestQuery)
        if (result && result.data) {
          commit('SET_BANNERS', result.data.banner)
          commit('SET_BANNERS_COUNT', result.data.banner_aggregate.aggregate.count)
        }
      } catch (err) {
        window.console.error(err)
      }
    },
    async get ({ commit }, bannerId) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchBannerByIdQuery,
          variables: {
            banner_id: bannerId
          }
        }

        const response = await apolloClient.query(requestQuery)
        if (response && response.data) {
          commit('SET_BANNER', response.data.banner[0])
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async create ({ commit }, banner) {
      try {
        const insertMutation = {
          mutation: createBannerMutation,
          variables: {
            data: {
              image: banner.image,
              title: banner.title,
              organization_id: banner.organization_id,
              start_date: banner.start_date,
              end_date: banner.end_date,
              max_view: banner.max_view,
              is_active: banner.is_active,
              created_by: banner.created_by
            }
          }
        }
        const result = await apolloClient.mutate(insertMutation)
        if (result && result.data) {
          commit('SET_BANNER', result.data.insert_banner.returning[0])
        }

        return result
      } catch (error) {
        window.console.error(error)
        throw new Error(error)
      }
    },
    async update ({ commit }, banner) {
      try {
        const updateMutation = {
          mutation: updateBannerMutation,
          variables: {
            bannerId: banner.id,
            data: {
              image: banner.image,
              title: banner.title,
              organization_id: banner.organization_id,
              start_date: banner.start_date,
              end_date: banner.end_date,
              max_view: banner.max_view,
              is_active: banner.is_active,
              updated_by: banner.updated_by
            }
          }
        }
        const result = await apolloClient.mutate(updateMutation)
        if (result && result.data) {
          commit('SET_BANNER', result.data.update_banner.returning[0])
        }

        return result
      } catch (error) {
        throw new Error(error)
      }
    },
    async imageUpload ({ commit }, formData) {
      axios.post(`${config.ENDPOINTS.CAT4MRO_APIHTTP}/api/item/image`, formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(function (response) {
        commit('SET_UPLOAD_RESULTS', response.data)
      }).catch(function (e) {
        console.error('UPLOAD FAILURE!!')
        Promise.reject(e)
      })
    },
    async deleteUploadedImage ({ commit }, path) {
      setTimeout(async () => {
        window.console.info('se borró la imagen... hipoteticamente', path)
      }, 800)
      return true
      /*       axios.post(`${config.ENDPOINTS.CAT4MRO_APIHTTP}/api/item/image`, image,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(function (response) {
        commit('SET_UPLOAD_RESULTS', response.data)
      }).catch(function (e) {
        Promise.reject(e)
      }) */
    }
  },
  mutations: {
    SET_BANNERS (state, data) {
      Vue.set(state, 'banners', data)
    },
    SET_BANNERS_COUNT (state, data) {
      Vue.set(state, 'banners_count', data)
    },
    SET_BANNER (state, data) {
      Vue.set(state, 'banner', data)
    },
    SET_UPLOAD_RESULTS (state, data) {
      Vue.set(state, 'uploadResult', data)
    }
  },
  getters: {
    bannersInfo: state => state.banners,
    bannersCountInfo: state => state.banners_count,
    bannerInfo: state => state.banner,
    uploadResultInfo: state => state.uploadResult
  }
}

export default banner



// WEBPACK FOOTER //
// ./src/store/modules/banner.js